import React, { useEffect, useState } from 'react'
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb'
import StudentSidebar from '../common/institutionSidebar'
import CircleProgress from '../../Instructor/instructor-dashboard/circleProgress'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { all_routes } from '../../router/all_routes'
import apiInstance from '../../../utility/apiInstance'
import { useSelector } from 'react-redux'
import { Application, Program } from '../../../core/types/types'
import InstructorSidebar from '../../Instructor/common/instructorSidebar'
import ProfileCard from '../common/profileCard'
import InstitutionSidebar from '../common/institutionSidebar'

const InstitutionDashboard = () => {

    const user = useSelector((state: any) => state.auth.user);
    const institution = user?.institution;
    const [applications, setApplications] = useState<[Application]>();
    const [programs, setPrograms] = useState<[Program]>();
    const [totalPrograms, setTotalPrograms] = useState<number>(0);
    const [approvedApplications, setApprovedApplications] = useState<[Application]>();
    const [totalApplications, setTotalApplications] = useState<number>(0);


    useEffect(() => {
        const fetchApplications = async () => {
            try {
                const response = await apiInstance.get("/api/applications", {
                    params: {
                        "where[institution][equals]": institution?.id || '',
                    },
                });

                const applications = response.data.docs;
                setApplications(applications);
                setTotalApplications(response?.data?.totalDocs)
                
                setApprovedApplications(applications.filter((item: Application) => item?.status === 'approved'))
            } catch (error) {
                console.error("Error fetching applications:", error);
            }
        };

        fetchApplications();
    }, [institution?.id]);

    useEffect(() => {
        const fetchInstitution = async () => {
            try {

                const programsRes = await apiInstance.get(`/api/programs?where[institution][equals]=${institution.id}`);
                setPrograms(programsRes.data.docs);
                setTotalPrograms(programsRes?.data?.totalDocs);

            } catch (err) {
                console.error("Failed to fetch institution:", err);
            }
        };

        if (institution?.id) fetchInstitution();
    }, [institution?.id]);

    return (
        <>
            <div className="content">
                <div className="container">
                    {/* profile box */}
                    <ProfileCard />
                    {/* profile box */}
                    <div className="row">
                        {/* sidebar */}
                        <InstitutionSidebar />
                        {/* sidebar */}
                        <div className="col-lg-9">
                            {/* <h5 className="mb-3 fs-18"></h5>
                            <div className="mb-5">
                                <ImageWithBasePath
                                    src="./assets/img/progress.svg"
                                    className="quiz-ans-bg1"
                                    alt="img"
                                />
                            </div> */}
                            <div className="row">
                                <div className="col-md-6 col-xl-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <span className="icon-box bg-primary-transparent me-2 me-xxl-3 flex-shrink-0">
                                                    <ImageWithBasePath src="assets/img/icon/graduation.svg" alt="" />
                                                </span>
                                                <div>
                                                    <span className="d-block">Total Programs</span>
                                                    <h4 className="fs-24 mt-1">{totalPrograms}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-xl-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <span className="icon-box bg-secondary-transparent me-2 me-xxl-3 flex-shrink-0">
                                                    <ImageWithBasePath src="assets/img/icon/book.svg" alt="" />
                                                </span>
                                                <div>
                                                    <span className="d-block">Total Applications</span>
                                                    <h4 className="fs-24 mt-1">{totalApplications}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-xl-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <span className="icon-box bg-success-transparent me-2 me-xxl-3 flex-shrink-0">
                                                    <ImageWithBasePath src="assets/img/icon/bookmark.svg" alt="" />
                                                </span>
                                                <div>
                                                    <span className="d-block">Approved Applications</span>
                                                    <h4 className="fs-24 mt-1">{approvedApplications?.length}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card bg-light quiz-ans-card">
                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-md-8">
                                            <div>
                                                <h6 className="mb-1">Complete Institution profile </h6>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="text-end">
                                                <Link
                                                    to={all_routes.institutionProfile}
                                                    className="btn btn-primary rounded-pill"
                                                >
                                                    Profile
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card bg-light quiz-ans-card">
                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-md-8">
                                            <div>
                                                <h6 className="mb-1">Manage Programs </h6>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="text-end">
                                                <Link
                                                    to={all_routes.institutionPrograms}
                                                    className="btn btn-primary rounded-pill"
                                                >
                                                    Programs
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h5 className="mb-3 fs-18">Recent Applications</h5>
                            <div>
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="card">
                                            <div className="card-body">
                                                {applications && applications?.length > 0 && applications.slice(0, 5)?.map((item) => (
                                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-3">
                                                        <div>
                                                            <h6 className="mb-1" style={{
                                                                maxWidth: "800px",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                            }} title={item?.program?.programName}>
                                                                {item?.program?.programName}
                                                            </h6>
                                                            <div className="d-flex align-items-center">
                                                                <span className="badge badge-sm bg-light border d-inline-flex me-3">
                                                                    <span
                                                                        className={
                                                                            item?.status === "pending"
                                                                                ? "text-warning fw-bold"
                                                                                : item?.status === "in_review"
                                                                                    ? "text-info fw-bold"
                                                                                    : item?.status === "approved"
                                                                                        ? "text-success fw-bold"
                                                                                        : item?.status === "declined"
                                                                                            ? "text-danger fw-bold"
                                                                                            : ""
                                                                        }
                                                                    >
                                                                        {item?.status || "pending"}
                                                                    </span>
                                                                </span>
                                                                <p className="small">
                                                                    Applicant :{" "}
                                                                    <span className="heading-color fw-semibold">
                                                                        {item.student?.firstName || ''} {item.student?.lastName || ''}
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex align-items-center">
                                                            {item?.createdAt ? new Date(item.createdAt).toLocaleDateString() : ''}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default InstitutionDashboard